export default "__VITE_ASSET__CAJ6_y9K__"